import styled from '@emotion/styled'

import theme from 'styles/theme'

export const ButtonWithIcon = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  right: 10px;
  top: 10px;
  width: 36px;
  height: 36px;
  background: ${theme.token('colors.green.a200')};
  border-radius: ${theme.token('borderRadius.small')};
  transition: background 0.1s ease-in;
  z-index: 99;
  cursor: pointer;

  &:hover {
    background: ${theme.token('colors.green.a250')};
  }

  &:focus {
    outline: none;
    box-shadow: none;
  }
`
